import { render, staticRenderFns } from "./wuzi2.vue?vue&type=template&id=1a9d0704&"
import script from "./wuzi2.vue?vue&type=script&lang=js&"
export * from "./wuzi2.vue?vue&type=script&lang=js&"
import style0 from "./wuzi2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports